const CACHE_KEY_PREFIX = 'shopInsuranceFilterDefaults';

function cacheKey(advisorId: string): string {
  return `${CACHE_KEY_PREFIX}:${advisorId}`;
}

export function getCachedFilterDefaults(
  advisorId: string,
): ShopInsuranceFilterDefaults | null {
  try {
    const raw = localStorage.getItem(cacheKey(advisorId));
    if (!raw) return null;
    return JSON.parse(raw) as ShopInsuranceFilterDefaults;
  } catch {
    return null;
  }
}

export function setCachedFilterDefaults(
  advisorId: string,
  defaults: ShopInsuranceFilterDefaults,
): void {
  try {
    localStorage.setItem(cacheKey(advisorId), JSON.stringify(defaults));
  } catch {
    // quota exceeded or private browsing — silently ignore
  }
}
